import React, { useEffect, useMemo, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import API_BASE_URL from "../config/api";
import PublicLayout from "../components/PublicLayout";

const PAGE_CONFIG = {
  about: {
    title: "About Us",
    eyebrow: "Owner Builder",
    description:
      "Learn more about the information and policies that guide our platform.",
    endpoint: "about-content",
  },
  terms: {
    title: "Terms & Conditions",
    eyebrow: "Legal",
    description:
      "Review the terms that apply when using Owner Builder services.",
    endpoint: "terms-content",
  },
  policy: {
    title: "Privacy Policy",
    eyebrow: "Privacy",
    description:
      "Understand how information is handled across Owner Builder experiences.",
    endpoint: "policy-content",
  },
};

const getContentValue = (payload) => {
  if (typeof payload === "string") return payload;
  return (
    payload?.content ||
    payload?.data?.content ||
    payload?.data?.page?.content ||
    payload?.page?.content ||
    ""
  );
};

const PublicContent = ({ type }) => {
  const page = useMemo(() => PAGE_CONFIG[type], [type]);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await axios.get(
          `${API_BASE_URL}/api/admin/content/${page.endpoint}`
        );
        setContent(getContentValue(res.data));
      } catch (err) {
        console.error("Fetch public content error:", err);
        setError("Content is not available right now.");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [page.endpoint]);

  return (
    <PublicLayout
      eyebrow={page.eyebrow}
      title={page.title}
      description={page.description}
    >
      <article className="public-content-panel">
        {loading ? (
          <div className="public-loading">
            <Spinner animation="border" />
            <p>Loading...</p>
          </div>
        ) : error ? (
          <Alert variant="danger">{error}</Alert>
        ) : content ? (
          <div className="public-rich-text">{content}</div>
        ) : (
          <Alert variant="info">Content has not been added yet.</Alert>
        )}
      </article>
    </PublicLayout>
  );
};

export default PublicContent;
